import React, { useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import ConfirmModal from '../ConfirmModal/ConfirmModal';
import LiveInput from '../../atoms/LiveInput/LiveInput'
import { TransparentSelectStyles } from '../../atoms/SelectBoxStyles/SelectBoxStyles';
import Select from 'react-select';
import { editEmployeeInitAction } from '../../../actions/employeesActions';
import Flatpickr from 'react-flatpickr'
import moment from 'moment/moment';
import './EmployeeTableRow.scss';
import OneThumb from '../OneThumb/OneThumb';

const EmployeeTableRow = ({ employee }) => {
  const [showPassword, setShowPassword ] = useState(false)
  const [showDeleteModal, setShowDeleteModal ] = useState(false)
  const [liveInputEditMode, setLiveInputEditMode] = useState(false);
  const [deletingError, setDeletingError] = useState('');
  const loggedInUser = useSelector(state => state.auth.user);
  const isCurrentUser = employee.id === loggedInUser.id;
  const dispatch = useDispatch();

  const employeeTypeFinder = (employee) => {
    switch (true) {
      case (employee.is_active === true && employee.is_admin === true):
        return 'Admin';
      case (employee.is_active === true && employee.is_admin === false):
        return 'User';
      case (employee.is_active === false && employee.is_admin === false):
        return 'Inactive';
      default:
        return 'User';
    }
  }

  const showHidePassword = () => {
    if (showPassword) {
      setShowPassword(false);
    } else {
      setShowPassword(true);
    }
  };

  const [employeeTypeSelection, setEmployeeTypeSelection] = useState({
    value: {
      is_active: employee?.is_active,
      is_admin: employee?.is_admin,
    },
    label: employeeTypeFinder(employee),
  });

  const employeeTypes = [
    { value: { is_active: true, is_admin: true }, label: 'Admin'},
    { value: { is_active: true, is_admin: false }, label: 'User'},
    { value: { is_active: false, is_admin: false }, label: 'Inactive'},
  ];

  const handleDeleteEmployee = () => {
    new Promise((resolve) => {
      resolve(dispatch(editEmployeeInitAction(employee.id, {
        is_admin: false,
        is_active: false,
      })));
    })
      .then((res) => {
        const { is_active, is_admin } = res.employeeData;
        if (!is_active && !is_admin) {
          setEmployeeTypeSelection({
            value: { is_admin: false, is_active: false },
            label: 'Inactive'
          });
          setShowDeleteModal(false);
        }
      })
      .catch((error) => {
        setDeletingError('Something went wrong!');
      })
  };

  return (
    <>
    {showDeleteModal && (
      <ConfirmModal
        onCancel={() => setShowDeleteModal(false)}
        onConfirm={handleDeleteEmployee}
      >
        <span className='w-100'>
          Are you sure you want delete <br /> 
          {`"${employee.name}"`} ? <br />
          The employee will disappear from the list
        </span>
        {deletingError ? <span className='w-100' style={{ color: 'rgba(203,37,122,1)' }}>{deletingError}</span> : ''}
      </ConfirmModal>
    )}

    <tr className="table-row">
      <td className="text-left">
          <OneThumb endpoint="users" model={employee} changeable />
      </td>

      <td className="text-left text-nowrap">
        <LiveInput id={employee.id} fieldName="name" endpoint="users" value={employee.name} />
      </td>

      <td className="text-center">
        <LiveInput id={employee.id} fieldName="email" endpoint="users" value={employee.email} />
      </td>

      <td className="text-right">
        <div className='user-password'>
          <span  className={`${!showPassword && !liveInputEditMode ? 'password' : ''}`}>
            <LiveInput id={employee.id} fieldName="password" endpoint="users" value={employee.password} onEditModeChange={setLiveInputEditMode} isPassword />
          </span>

          <span className= {`${liveInputEditMode ? 'hide-icons' : '' } eye-icon`} onClick={showHidePassword} role="presentation">
            {showPassword ? <i className="zwicon-eye-slash" aria-hidden="true" /> : <i className="zwicon-eye" aria-hidden="true" />}
          </span>
        </div>
      </td>

      <td className="text-center">
        <LiveInput id={employee.id} fieldName="hours_per_week" endpoint="users" value={employee.hours_per_week} />
      </td>

      <td className="text-center">
          <Flatpickr
            className="modal-date-picker "
            placeholder="-"
            value={employee.starting_date || null}
            onChange={(selectedDates) => {
              const selectedDate = selectedDates[0];
              const formattedDate = moment(selectedDate).format('YYYY-MM-DD');
              dispatch(editEmployeeInitAction(employee.id, { starting_date: formattedDate }));
            }}
            options={{
              altFormat: 'l, J \\of F ‘y',
              altInput: true,
            }}
          />  
      </td>

      <td className="text-center">
        <span className={`user-status ${isCurrentUser ? 'disabled' : ''}`}>
            <Select
              options={employeeTypes}
              value={employeeTypes.find(option => option.label === employeeTypeSelection.label)}
              onChange={(seleted) => {
                setEmployeeTypeSelection(seleted);
                dispatch(editEmployeeInitAction(employee.id, {
                  is_admin: seleted.value.is_admin,
                  is_active: seleted.value.is_active,
                }));
              }}
              styles={TransparentSelectStyles}
              menuPortalTarget={document.body}
              isDisabled={isCurrentUser}
            />
          </span>
      </td>

      <td className="text-center">
        <button className="delete-button" disabled={isCurrentUser} type="button" onClick={() => setShowDeleteModal(true)}>
          <span className={`zwicon-trash ${isCurrentUser ? 'disabled' : ''}`} />
        </button>
      </td>
    </tr>
    </>
  );
};

export default EmployeeTableRow;
